import { render, staticRenderFns } from "./BrandPartsGroupAddLayer.vue?vue&type=template&id=5d68c729&scoped=true&"
import script from "./BrandPartsGroupAddLayer.vue?vue&type=script&lang=js&"
export * from "./BrandPartsGroupAddLayer.vue?vue&type=script&lang=js&"
import style0 from "./BrandPartsGroupAddLayer.vue?vue&type=style&index=0&id=5d68c729&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d68c729",
  null
  
)

export default component.exports